import React, { useState, ChangeEvent, useEffect } from 'react';
import './settings.scss';
import { companyService } from "../../services/apiService";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const SettingsPage: React.FC = () => {
  const user = useSelector((state: RootState) => state.user.user);

  const [firstDayOfWeek, setFirstDayOfWeek] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (!user || !user.companyId) return;

    const getSettings = async () => {
      try {
        const theCompany = await companyService.getCompanySettings(user, user.companyId!);
        if (theCompany.settings && theCompany.settings.length > 0) {
          const decodedSettings = JSON.parse(theCompany.settings);
          setFirstDayOfWeek(decodedSettings.firstDayOfWeek || 0);
        }
      } catch (error) {
        console.error('Fetch Settings Failed:', error);
      }
    };

    getSettings();
  }, [user]);

  const handleFirstDayOfWeekChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setFirstDayOfWeek(parseInt(event.target.value));
  };

  const handleSave = async () => {
    if (!user || !user.companyId) {
      return;
    }

    setLoading(true);
    setSaved(false);

    try {
      await companyService.updateCompanySettings(user, user.companyId, {
        settings: JSON.stringify({ firstDayOfWeek })
      });
      setSaved(true);

      // Clear saved message after 3 seconds
      setTimeout(() => setSaved(false), 3000);
    } catch (error) {
      console.error('Save Settings Failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-container">
      <div className="section">
        <h2 className="section-title">Settings</h2>
        <div className="toggle-container">
          <label className="toggle-label" htmlFor="firstDayOfWeek">First Day of the Week</label>
          <select
            id="firstDayOfWeek"
            value={firstDayOfWeek}
            onChange={handleFirstDayOfWeekChange}>
            <option value={0}>Sunday</option>
            <option value={1}>Monday</option>
          </select>
        </div>
      </div>
      {/*<div className="section">*/}
      {/*  <h2 className="section-title">Language</h2>*/}
      {/*  <select className="language-select" value={language} onChange={handleLanguageChange}>*/}
      {/*    <option value="en">English</option>*/}
      {/*    <option value="es">Spanish</option>*/}
      {/*    <option value="fr">French</option>*/}
      {/*    <option value="de">German</option>*/}
      {/*  </select>*/}
      {/*</div>*/}
      <button
        className="save-button"
        onClick={handleSave}
        disabled={loading}
      >
        {loading ? 'Saving...' : 'Save Settings'}
      </button>
      {saved && (
        <div className="save-message">
          Settings saved successfully!
        </div>
      )}
    </div>
  );
};

export default SettingsPage;
